/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useContext, useEffect, useState } from "react";
import { Divider } from "@mui/material";
// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import { AuthContext } from "context/authContext";
// ...
import { signInRevendeur } from "api/revendeur";
// import { socket } from "socket";
import Swal from "sweetalert2";
import { setCookie } from "utils/cookies";

function RevendeurSignIn() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  // const [rememberMe, setRememberMe] = useState(false);
  // const handleSetRememberMe = () => setRememberMe(!rememberMe);

  // const [isConnected, setIsConnected] = useState(socket.connected);

  const [userForm, setUserForm] = useState({
    email: "",
    password: "",
  });

  // useEffect(() => {
  //   const onConnect = () => {
  //     console.log("Dashboard socket is connected");
  //     setIsConnected(true);
  //   };
  //   const onDisconnect = () => {
  //     console.log("Dashboard socket is disconnected");
  //     setIsConnected(false);
  //   };

  //   socket.on("connect", onConnect);
  //   socket.on("disconnect", onDisconnect);

  //   return () => {
  //     socket.off("connect", onConnect);
  //     socket.off("disconnect", onDisconnect);
  //   };

  //   clearAllCockies()
  // }, []);

  const clearAllCockies = () => {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserForm({ ...userForm, [name]: value });
  };

  const handleSignIn = async () => {
    try {
      const credentials = { email: userForm.email, password: userForm.password };

      const response = await signInRevendeur(credentials.email, credentials.password);

      console.log("Data received from Revendeur sign-in:", response);

      if (!response || !response.userInfo || !response.token || !response.role) {
        console.error("Incomplete data received from server:", response);
        Swal.fire({
          title: "Error!",
          text: "Received incomplete data from server.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const { userInfo, token: tokenData, role: userRole } = response;

      await setCookie("T6hVzR7c0g3maM3F", tokenData.content);
      await setCookie("02hfCmUqpk66w4uG", tokenData.iv);
      await setCookie("3F2Mb2pJ1YRro5Z4", userInfo._id);
      localStorage.setItem("userRole", userRole);
      localStorage.setItem("userInfo", JSON.stringify(userInfo));

      if (authContext && typeof authContext.login === "function") {
        authContext.login(userInfo, tokenData, userRole);
      }

      navigate("/reservations/reservations");
    } catch (error) {
      console.error("Error caught in handleSignIn:", error);
      let errorMessage = "Login failed. Please check your credentials.";
      if (error.response && error.response.data && error.response.data.error) {
        errorMessage = error.response.data.error;
      }
      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                name="email"
                value={userForm.email}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                name="password"
                value={userForm.password}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" onClick={handleSignIn} fullWidth>
                Sign In
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default RevendeurSignIn;
